import React, { FC } from "react";
import Logo from "components/Logo/Logo";
import MenuBar from "components/MenuBar/MenuBar";
import Navigation from "components/Navigation/Navigation";

const MainNav2Logged: FC = () => {
  return (
    <div className="nc-MainNav2Logged relative z-10 bg-white dark:bg-neutral-900 border-b border-slate-100 dark:border-slate-700">
      <div className="w-full mx-auto px-2 lg:px-4">
        <div className="h-20 flex items-center justify-between min-w-0">

          {/* Mobile: menu hamburger + logo collé, centré verticalement */}
          <div className="flex items-center lg:hidden gap-2 h-full">
            <MenuBar />
            <div className="flex-shrink-0 whitespace-nowrap w-32 flex items-center h-full">
              <Logo />
            </div>
          </div>

          {/* Desktop: logo + navigation */}
          <div className="hidden lg:flex items-center flex-shrink gap-2 min-w-0 h-full">
            <div className="flex-shrink-0 w-40 h-10 whitespace-nowrap flex items-center">
              <Logo />
            </div>
            <div className="flex items-center gap-4 flex-shrink min-w-0">
              <Navigation />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav2Logged;
